export default {
    mapper: {
        relations: 'Custom Polymorphic Pivot',
    },
};
